/* eslint-disable */
import React, {PropTypes} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import moment from 'moment';
var Datetime = require('react-datetime');
import * as atendimentoActions from './actions/atendimentoActions'
import InputMask from 'react-input-mask';
import Captcha from './Captcha'
import Helpers from './util/Helpers'
import ConfigD from './util/ConfigD'
import './css/loginForm.css'
import './css/step.css'
import 'jquery-validation';
import $ from 'jquery';
import Alert from 'react-s-alert';


class RecuperarProtocoloForm extends React.Component {
 
    constructor(props, context) {
        super(props, context);
        
        this.state = {
            erro:'',
            errEmail: '*Campo obrigatório',
            cpf: '',
            email:'',
            errDtNascimento: '*Campo obrigatório',
            dtNascimento:'',
            captchaValue:'',
            captchaUserValue:'',
            captchaValido:false,
            idx:1,
            stateShowErro:false,
            msg:'',
            msgTitulo:''




        };
        this.solicitarProtocolo = this.solicitarProtocolo.bind(this);
        this.setCpf = this.setCpf.bind(this);
        this.setDtNascimento = this.setDtNascimento.bind(this);

        this.refreshCaptcha = this.refreshCaptcha.bind(this);
        this.setCaptchaValue = this.setCaptchaValue.bind(this);
        this.setCaptchaUserValue = this.setCaptchaUserValue.bind(this);
        this.captchaValido = this.captchaValido.bind(this);

    }

    setCpf(e) {
        this.setState({
            cpf: e.target.value
        })
    }

    setDtNascimento(e) {
        this.setState({
            dtNascimento: e.target.value
        })
    }

    captchaValido(){
        
        if(this.state.captchaValue !== '' && this.state.captchaUserValue !== ''){
            if (this.state.captchaValue.toLowerCase() === this.state.captchaUserValue.toLowerCase()) {
                return true;
            }
        }
        else{
            return false;
        }
    }
    refreshCaptcha(){
        var i = this.state.idx+1;
        this.setState({idx:i});
    }

    captchaValido(){
        
        if(this.state.captchaValue !== '' && this.state.captchaUserValue !== ''){
            if (this.state.captchaValue.toLowerCase() === this.state.captchaUserValue.toLowerCase()) {
                return true;
            }
        }
        else{
            return false;
        }
    }

    setCaptchaValue(text){
        
        this.setState({
            captchaValue: text
        })
    }

    setCaptchaUserValue(val) {
        this.setState({
            captchaUserValue: val
        })
    }
    

    solicitarProtocolo(event){

        if (event != undefined) {
            event.preventDefault();
            event.stopPropagation();
        }

        if ($('#consultar-form').valid()) {
           //console.log('validou')
           var email = $('#emailLogin').val();
            var cpfcnpj = $('#txtCpf').val();

            var data = {
                email: email,
                cpfcnpj: cpfcnpj
            }
           //console.log('data - ', data);
            this.props.actions.ObterAtendimentosCidadao(data).catch(error => {
                
                if(error===null){
                    this.setState({erro: 'Nenhum registro encontrado'})
                    $('.alert-danger', $('#consultar-form')).show();
                }else{
                    Alert.warning(!$.isEmptyObject(error) ? error : 'erro inesperado ' + error.statusText, {
                        position: 'top-right',
                        effect: 'slide',
                        offset: 172,
                        timeout: 5000
                    });

                }
            });;

        }


    }

    componentDidMount() {
        var self = this;
        $.validator.addMethod('validarCaptcha', function (value, element) {
          
          
            var ret =   self.state.captchaValue.toLowerCase() === value.toLowerCase()?true:false;
          return ret;
            
        }, 'Inválido!'); 

        $('.msgAlerta').hide();
        $('.formRecuperar').show();
        
        //this.props.actionCliente.validarCliente(null);
        $('.alert-danger', $('#consultar-form')).hide();
        $('#consultar-form').validate({
            errorElement: 'span',
            errorClass: 'help-block',
            focusInvalid: true,
            rules: {
                emailLogin: {
                    required: true,
                    email: true
                },
                txtCpf: {
                    required: true
                },
                txtCaptcha: {
                    required: true,
                    validarCaptcha: true,
                }
            },

            messages: {
                emailLogin: {
                    required: "E-mail necessário.",
                    email: 'Email inválido'
                },
                txtCpf: {
                    required: "CPF necessário.",
                    minlength : 'Informe um cpf correto',
                },
                txtCaptcha: {
                    required: "Captcha necessário.",
                    validarCaptcha : 'Dados incorretos',
                },
            },

            invalidHandler: function (event, validator) {
                //$('.alert-danger', $('#consultar-form')).show();
            },

            highlight: function (element) {
                $(element)
                    .closest('.form-group').addClass('has-error');
            },

            success: function (label) {
                label.closest('.form-group').removeClass('has-error');
                label.remove();
            },

            errorPlacement: function (error, element) {
                error.insertAfter(element.closest('.input-icon'));
            }
        });

    }
    
    componentWillReceiveProps(nextProps) {
        
        if (!$.isEmptyObject(nextProps.enviado) && this.props.enviado !== nextProps.enviado) {
            //console.log('apresentar msg de sucesso', nextProps.enviado)
            $('.msgAlerta').show();
            $('.formRecuperar').hide();
            if(nextProps.enviado.dado){
                this.setState({
                    msg:'Tudo bem! Dentro de instantes você receberá um e-mail, contendo todos os atendimentos já abertos para esse CPF e e-mail',
                    msgTitulo:'Solicitação efetuada'
                });
            }
            else{
                this.setState({
                    msg:'Não foram encontrados resultados com os dados informados',
                    msgTitulo:'Dados incorretos:'
                });
            }

            //this.context.router.push(ConfigD.getServerBase() + '/visualizarProtocolo');
        }
    }

    render() {
        //console.log('servicos', this.props.servicos);
        // if($.isEmptyObject(this.props.servicos)){
        //   return <div/>
        // }
        //console.log('this.props.servicoCalculado ' , this.state.servicoSelecionado)

    return (

        <div>
            <form method="post" id='consultar-form' >
            
            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 msgAlerta"  style={{ display: 'none' }} >
                <div className="contact-box-Blue widget">
                    {/* <h3 className='titulo-Contact-box-Blue'>{this.state.msgTitulo}</h3> */}
                    <i className="fa fa-bullhorn"></i>
                    <div className='text-aling-left'>
                     <p>Prezado Cliente,</p><br/>
                    <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{this.state.msg}</p><br/>
                    </div>
                </div>
            </div>            


                <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 formRecuperar"  style={{ display: '' }}>
                    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                        <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                            <h3 className="title">Informe recuperar seus dados:</h3>
                        </div>
                        <div className="col-lg-6 col-md-6 col-sm-6 col-xs-12">

                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="alert alert-danger display-hide">
                                    <button className="close" data-close="alert"></button>
                                    <span tabIndex="0"> {this.state.erro} </span>
                                </div>
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>E-mail:</b></label>
                                        <input type="text" className="form-control" placeholder="Informe o e-mail" name="emailLogin" id='emailLogin' />
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>CPF:</b></label>
                                        <InputMask type='text' mask="999.999.999-99" placeholder='CPF' className="form-control" value={this.state.cpf} onChange={this.setCpf} ref='txtCpf' name="txtCpf" id="txtCpf" />
                                    </div>
                                </div>
                            </div>
                            {/* <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <div className="form-group">
                                    <div className="input-icon">
                                        <label><b>Senha:</b></label>
                                        <InputMask type='text' mask="99/99/9999" size="10" placeholder='Data de nascimento' className="form-control" value={this.state.dtNascimento} onChange={this.setDtNascimento}  ref='txtDtNascimento' name="txtDtNascimento" id="txtDtNascimento" />
                                    </div>
                                </div>
                            </div> */}
                            <div className="form-group">
                                <div className="input-icon">
                                    <Captcha ref='txtCaptcha' name="txtCaptcha" id="txtCaptcha"  idx={this.state.idx} refreshCaptcha={this.refreshCaptcha} setCaptchaValue={this.setCaptchaValue} setCaptchaUserValue={this.setCaptchaUserValue}  showError={this.state.showError} />
                                </div>
                            </div>
                            <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                <button type="submit" onClick={this.solicitarProtocolo}>Solicitar protocolo e senha</button>
                            </div>
                        </div>
                    </div>
                </div>

            </form>
        </div>
    );
  }
}

RecuperarProtocoloForm.protoType = {
    //actionCliente: PropTypes.object.isRequired
}
RecuperarProtocoloForm.contextTypes = {
  router: React.PropTypes.object
};

function mapStateToProps(state, ownProps){
    
    return {
        enviado: state.atendimento.enviado
    };
}

function mapDispatchToProps(dispatch){
   return {
        
       actions: bindActionCreators(atendimentoActions, dispatch)
    };
    
}

export default connect(mapStateToProps, mapDispatchToProps)(RecuperarProtocoloForm);



/** WEBPACK FOOTER **
 ** ./src/components/RecuperarProtocoloForm.js
 **/